module.exports = __webpack_public_path__ + "static/img/leader2.ed24c14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/leader2.png
// module id = PJ9W
// module chunks = 1